import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard } from '@shapeable/ui';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      font-size: ${40/15}em;
      letter-spacing: -0.03em;
      margin-bottom: ${theme.UNIT(6)};
      font-family: ${theme.FONT('sans')};
    }

    .shp--page-layout-standard__subtitle {
      font-size: ${11/12}em;
    }
  `,
  landscape: css`
    .shp--page-layout-standard__title {
      font-size: ${55/15}em;
      margin-bottom: ${theme.UNIT(8)};
    }

    .shp--page-layout-standard__subtitle {
      font-size: ${16/12}em;
    }
  `,
  desktop: css`
    .shp--page-layout-standard__title {
      font-size: ${65/15}em;
      margin-bottom: ${theme.UNIT(10)};
    }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <My.Layout 
      entity={entity}
      slices={slices}
      headerProps={{ 
        showOverlayGradient: true, 
        variant: 'overlay', 
        backgroundColor: '#000000',
        fadeColor: '#0000000', 
       }}
      className={className}
    />
  )
};
